import React, { FunctionComponent } from 'react';
import Button, { ButtonProps } from '../../common/Button';

const LandingButton: FunctionComponent<ButtonProps> = (props: ButtonProps) => {
    return (
        <Button variant={'primary'} {...props} />
    )
}

export default LandingButton